import request from "@/utils/request.js";

/**
 * M站优惠券列表
 * @param params
 * @returns {AxiosPromise}
 */
export function listUserNurseCouponApp(params) {
  return request({
    url: "/operateService/api/app/couponApp/listUserNurseCouponApp",
    method: "post",
    data: params
  });
}

/**
 * 用户卡券列表分页
 * @param params
 * @returns {AxiosPromise}
 */
export function listUserCouponPage(params) {
  return request({
    url: "/userService/api/user/coupon/listUserCouponPage",
    method: "post",
    data: params
  });
}
